import { AWStageDto } from '@api/Api';
import moment from 'moment';

type GetValidDeadlineForStageProps = {
  stages: AWStageDto[];
  stage: AWStageDto;
  v: moment.Moment;
};

export default function getValidDeadlineDateForStage({
  stages,
  stage,
  v
}: GetValidDeadlineForStageProps) {
  const stagesLength = stages.length;
  const lastStageIndex = stagesLength - 1;
  const currentStageIndex = stages.findIndex((it) => it.id === stage.id);

  if (currentStageIndex === 0) {
    const nearestNextDeadline = stages.find(
      (it, idx) => idx !== currentStageIndex && it.deadline
    )?.deadline;
    if (nearestNextDeadline) {
      const canMangeWithTime = isCurrentTimeGreater({
        firstDate: stage.deadline,
        secondDate: nearestNextDeadline
      });
      return !v.isBetween(
        moment().startOf('day'),
        moment(nearestNextDeadline).endOf('day'),
        undefined,
        `[${!canMangeWithTime ? ')' : ']'}`
      );
    }
  }

  if (lastStageIndex === currentStageIndex) {
    const nearestPrevDeadline = stages
      .filter((_, idx) => idx < currentStageIndex)
      .reverse()
      .find((it) => it.deadline)?.deadline;

    const canMangeWithTime = isCurrentTimeGreater({
      firstDate: nearestPrevDeadline,
      secondDate: stage.deadline || nearestPrevDeadline
    });

    if (canMangeWithTime) return v.isBefore(moment(nearestPrevDeadline));
    return v.isBefore(moment(stage.deadline));
  }

  if (currentStageIndex > 0 && currentStageIndex < lastStageIndex) {
    const nearestPrevDeadline = stages
      .filter((_, idx) => idx < currentStageIndex)
      .reverse()
      .find((it) => it.deadline)?.deadline;

    const nearestNextDeadline = stages
      .filter((_, idx) => idx > currentStageIndex)
      .find((it) => it.deadline)?.deadline;

    const canMangeWithPrevTime = isCurrentTimeGreater({
      firstDate: nearestPrevDeadline,
      secondDate: stage.deadline
    });

    if (!nearestNextDeadline) {
      if (canMangeWithPrevTime) return v.isBefore(moment(nearestPrevDeadline));
      return v.isBefore(moment(stage.deadline));
    }

    const canMangeWithNextTime = isCurrentTimeGreater({
      firstDate: stage.deadline,
      secondDate: nearestNextDeadline
    });
    return !v.isBetween(
      moment(nearestPrevDeadline).endOf('day'),
      moment(nearestNextDeadline).endOf('day'),

      undefined,
      `${!canMangeWithPrevTime ? '(' : '['}${!canMangeWithNextTime ? ')' : ']'}`
    );
  }

  return v.isBefore(moment().local());
}

type IsCurrentTimeGreaterProps = {
  firstDate: string | null | undefined;
  isFirstDateEndOfDay?: boolean;
  secondDate: string | null | undefined;
};

function isCurrentTimeGreater({
  firstDate,
  secondDate
}: IsCurrentTimeGreaterProps) {
  return (
    minutesOfDay(moment(firstDate).local()) <=
    minutesOfDay(moment(secondDate).local())
  );
}

function minutesOfDay(m: moment.Moment) {
  return m.minutes() + m.hours() * 60;
}
